import dayjs from 'dayjs';

export class MockedVitodens300Features {
  mock(installationId: number, gatewaySerial: string) {
    return [
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.dhw',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.dhw',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [
                {
                  timestamp: '2020-03-20T15:42:51.000Z',
                  errorCode: '1d',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-03-20T15:41:51.000Z',
                  errorCode: 'fe',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-03-20T15:41:51.000Z',
                  errorCode: 'b7',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-03-17T09:43:26.000Z',
                  errorCode: '1d',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-03-17T09:42:26.000Z',
                  errorCode: 'fe',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-03-17T09:42:26.000Z',
                  errorCode: 'b7',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-03-13T06:38:11.000Z',
                  errorCode: '1d',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-03-13T06:37:11.000Z',
                  errorCode: 'fe',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-03-13T06:37:11.000Z',
                  errorCode: 'b7',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-03-12T07:26:33.000Z',
                  errorCode: '1d',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
              ],
              gone: [],
            },
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.errors.history',
        timestamp: '2020-04-30T06:53:27.032Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors.history',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              tue: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              wed: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              thu: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              fri: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              sat: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              sun: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.schedule',
        timestamp: '2020-04-29T06:49:43.354Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.schedule',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          temperature: {
            value: 28,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.reduced/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.reduced',
        timestamp: '2020-04-30T07:25:24.462Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.reduced',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 7,
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 4,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 4,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.comfort',
        timestamp: '2020-04-29T06:49:50.132Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.comfort',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors.temperature',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors.temperature',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.circulation',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.circulation',
      },
      {
        properties: {
          enabled: {
            value: ['0'],
            type: 'array',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits',
        timestamp: '2020-04-29T06:49:43.438Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits',
      },
      {
        properties: {
          day: {
            value: [0, 0, 0, 0, 0, 0, 0, 0],
            type: 'array',
          },
          week: {
            value: [
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
            ],
            type: 'array',
          },
          month: {
            value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            type: 'array',
          },
          year: {
            value: [0, 0, 0],
            type: 'array',
          },
          unit: {
            value: 'kilowattHour',
            type: 'string',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption.dhw',
        timestamp: '2020-03-03T12:07:30.968Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption.dhw',
      },
      {
        properties: {
          status: {
            value: 'on',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps.primary',
        timestamp: '2020-04-29T06:49:43.360Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps.primary',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.sensors.temperature',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.sensors.temperature',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device.time',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.time',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.operating',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 19,
            type: 'number',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.eco/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.eco/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.eco',
        timestamp: '2020-04-30T07:25:24.410Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.eco',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device',
      },
      {
        properties: {
          value: {
            value: 24,
            unit: 'celsius',
            type: 'number',
          },
          unit: {
            value: 'celsius',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.temperature',
        timestamp: '2020-04-29T06:49:43.352Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.temperature',
      },
      {
        properties: {
          activeMonthSinceLastService: {
            value: 0,
            type: 'number',
          },
          serviceIntervalMonths: {
            value: 0,
            type: 'number',
          },
          lastService: {
            value: '',
            type: 'string',
          },
          serviceDue: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.service.timeBased',
        timestamp: '2020-04-29T06:49:43.354Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.service.timeBased',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.dhw.pumps.circulation',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.dhw.pumps.circulation',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.dhw',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.dhw',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.charging',
        timestamp: '2020-04-29T06:49:43.359Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.charging',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature',
      },
      {
        properties: {
          status: {
            value: 'error',
            unit: 'celsius',
            type: 'string',
          },
          unit: {
            value: 'celsius',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors.temperature.main',
        timestamp: '2020-04-29T06:49:43.351Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors.temperature.main',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              tue: [
                {
                  start: '14:00',
                  end: '16:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              wed: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              thu: [],
              fri: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              sat: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              sun: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['on'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'off',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.schedule',
        timestamp: '2020-04-29T06:49:43.445Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.schedule',
      },
      {
        properties: {
          value: {
            value: 'forcedReduced',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.modes.active/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['standby', 'dhw', 'dhwAndHeating', 'forcedReduced', 'forcedNormal'],
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.active',
        timestamp: '2020-04-29T06:49:43.509Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.active',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.sensors.temperature',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.sensors.temperature',
      },
      {
        properties: {
          status: {
            value: 'off',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.frostprotection',
        timestamp: '2020-04-29T06:49:43.353Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.frostprotection',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.sensors',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.sensors',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '',
            type: 'string',
          },
          end: {
            value: '',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.holiday/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                  sameDayAllowed: false,
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.holiday/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                  sameDayAllowed: false,
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.holiday/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.holiday',
        timestamp: '2020-04-29T06:49:43.358Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.holiday',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.dhw.pumps',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.dhw.pumps',
      },
      {
        properties: {
          value: {
            value: 0,
            type: 'number',
          },
          top: {
            value: 0,
            type: 'number',
          },
          middle: {
            value: 0,
            type: 'number',
          },
          bottom: {
            value: 0,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.charging.level',
        timestamp: '2020-04-29T06:49:43.359Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.charging.level',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.dhw',
        timestamp: '2020-04-29T06:49:43.355Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.dhw',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '',
            type: 'string',
          },
          end: {
            value: '',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                  sameDayAllowed: false,
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                  sameDayAllowed: false,
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.operating.programs.holiday',
        timestamp: '2020-04-29T06:49:43.362Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating.programs.holiday',
      },
      {
        properties: {
          value: {
            value: 46,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTargetTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature.main/setTargetTemperature',
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 60,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature.main',
        timestamp: '2020-04-29T06:49:43.437Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature.main',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.oneTimeCharge/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.oneTimeCharge/deactivate',
            name: 'deactivate',
            isExecutable: true,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.oneTimeCharge',
        timestamp: '2020-04-29T06:49:43.360Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.oneTimeCharge',
      },
      {
        properties: {
          status: {
            value: 'error',
            unit: 'celsius',
            type: 'string',
          },
          unit: {
            value: 'celsius',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature.supply',
        timestamp: '2020-04-29T06:49:43.359Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature.supply',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.dhw.pumps.circulation',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.dhw.pumps.circulation',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps',
      },
      {
        properties: {
          status: {
            value: 'on',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps.circulation',
        timestamp: '2020-04-29T06:49:43.360Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps.circulation',
      },
      {
        properties: {
          shift: {
            type: 'number',
            value: 6,
          },
          slope: {
            type: 'number',
            value: 1.3,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.curve/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.2,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.curve',
        timestamp: '2020-04-29T06:49:43.353Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.curve',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.modes',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.modes',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.gas',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes',
      },
      {
        properties: {
          status: {
            value: 'error',
            type: 'string',
          },
          errorCode: {
            value: 162,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0.errorStatus',
        timestamp: '2020-04-29T06:49:43.352Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0.errorStatus',
      },
      {
        properties: {
          value: {
            value: 0,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burner.current.power',
        timestamp: '2020-04-29T06:49:43.352Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burner.current.power',
      },
      {
        properties: {
          hours: {
            value: 0,
            type: 'number',
            unit: 'hours',
          },
          starts: {
            value: 8,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0.statistics',
        timestamp: '2020-04-29T06:49:43.352Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0.statistics',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.standby',
        timestamp: '2020-04-29T06:49:43.357Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.standby',
      },
      {
        properties: {
          value: {
            value: 41.7,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
          unit: {
            value: 'celsius',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.outlet',
        timestamp: '2020-04-30T06:53:34.901Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.outlet',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0',
        timestamp: '2020-04-29T06:49:43.352Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.dhw.pumps',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.dhw.pumps',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [
                {
                  errorCode: '1d',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                  timestamp: '2020-03-20T16:42:27.962Z',
                },
                {
                  errorCode: 'fe',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                  timestamp: '2020-03-03T12:07:18.796Z',
                },
                {
                  errorCode: 'b7',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                  timestamp: '2020-03-03T12:07:18.796Z',
                },
              ],
              gone: [],
            },
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.errors.active',
        timestamp: '2020-03-25T20:39:35.869Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors.active',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.forcedNormal',
        timestamp: '2020-04-29T06:49:43.357Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.forcedNormal',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.dhw.pumps.circulation',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.dhw.pumps.circulation',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.circulation',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.circulation',
      },
      {
        properties: {
          value: {
            value: 0,
            type: 'number',
            unit: 'percent',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0.modulation',
        timestamp: '2020-04-29T06:49:43.352Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0.modulation',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw',
        timestamp: '2020-04-29T06:49:43.361Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.operating.programs',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating.programs',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.dhw.pumps',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.dhw.pumps',
      },
      {
        properties: {
          day: {
            value: [0, 0, 0, 0, 0, 0, 0, 0],
            type: 'array',
          },
          week: {
            value: [
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
            ],
            type: 'array',
          },
          month: {
            value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            type: 'array',
          },
          year: {
            value: [0, 0, 0],
            type: 'array',
          },
          unit: {
            value: 'kilowattHour',
            type: 'string',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption.heating',
        timestamp: '2020-03-03T12:07:26.645Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption.heating',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 19,
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.normal/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.normal',
        timestamp: '2020-04-30T07:25:24.415Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.normal',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.controller',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.controller',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.power',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.power',
      },
      {
        properties: {
          value: {
            value: 229,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device.time.offset',
        timestamp: '2020-04-29T06:49:43.359Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.time.offset',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.pumps',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.pumps',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.dhwAndHeating',
        timestamp: '2020-04-29T06:49:43.355Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.dhwAndHeating',
      },
      {
        properties: {
          value: {
            value: 'reduced',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.active',
        timestamp: '2020-04-29T06:49:50.137Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.active',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.forcedReduced',
        timestamp: '2020-04-29T06:49:43.357Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.forcedReduced',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.service',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.service',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.standby',
        timestamp: '2020-04-29T06:49:43.358Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.standby',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.sensors',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.errors',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs',
        timestamp: '2020-04-29T06:49:43.120Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs',
      },
      {
        properties: {
          value: {
            value: 16.8,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
          unit: {
            value: 'celsius',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature.outside',
        timestamp: '2020-04-30T06:53:36.886Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature.outside',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors.temperature',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors.temperature',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.circulation',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.circulation',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burner.current',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burner.current',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.dhw',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.dhw',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.multiFamilyHouse',
        timestamp: '2020-04-29T06:49:43.361Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.multiFamilyHouse',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              tue: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              wed: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              thu: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              fri: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              sat: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              sun: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.pumps.circulation.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['on'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'off',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps.circulation.schedule',
        timestamp: '2020-04-29T06:49:43.517Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps.circulation.schedule',
      },
      {
        properties: {
          value: {
            value: '����������������',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.controller.serial',
        timestamp: '2020-04-29T06:49:43.359Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.controller.serial',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors',
      },
      {
        properties: {
          value: {
            value: '����������������',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.serial',
        timestamp: '2020-04-29T06:49:43.352Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.serial',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 0,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.external',
        timestamp: '2020-04-29T06:49:43.358Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.external',
      },
      {
        properties: {
          status: {
            value: 'off',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.circulation.pump',
        timestamp: '2020-04-29T06:49:43.361Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.circulation.pump',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.heating',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.heating',
      },
      {
        properties: {
          value: {
            value: 46,
            type: 'number',
          },
        },
        commands: {
          setTargetTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature/setTargetTemperature',
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 60,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature',
        timestamp: '2020-04-29T06:49:43.351Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: 'He',
            type: 'string',
          },
          type: {
            value: 'heatingCircuit',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0',
        timestamp: '2020-04-29T06:49:43.352Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.configuration',
        timestamp: '2020-04-29T06:49:43.121Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration',
      },
      {
        properties: {
          value: {
            value: 41.7,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
          unit: {
            value: 'celsius',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.hotWaterStorage',
        timestamp: '2020-04-30T06:53:34.901Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.hotWaterStorage',
      },
      {
        isEnabled: true,
        isReady: true,
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.geofencing',
        deviceId: '0',
        timestamp: '2020-04-30T07:49:10.649Z',
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          status: {
            type: 'string',
            value: 'home',
          },
        },
        commands: {},
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.geofencing',
      },
      {
        isEnabled: true,
        isReady: true,
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.geofencing',
        deviceId: '0',
        timestamp: '2020-04-30T07:49:10.649Z',
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          status: {
            type: 'string',
            value: 'home',
          },
        },
        commands: {},
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.geofencing',
      },
      {
        isEnabled: true,
        isReady: true,
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.geofencing',
        deviceId: '0',
        timestamp: '2020-04-30T07:49:10.649Z',
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          status: {
            type: 'string',
            value: 'home',
          },
        },
        commands: {},
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.geofencing',
      },
    ];
  }
}
